// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QcRZ2","categoriesWrapper":"styles_categoriesWrapper__Jx5T4","selectWrapper":"styles_selectWrapper__OaGU5"};